export { default } from './NumberVerificationPassportHolder';
